<fdx-nav>
  <h2 fdxNavTitle class="fdx-c-navbar__title">{{ 'title' | translate }}</h2>
  @if (isOverviewEnabled !== 'disabled') {
    <fdx-nav-item class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only">
      <a fdxNavButton [href]="navUrls.profileOverview" >
        <ciam-icon fdxNavIcon key="brand_home_s"></ciam-icon>
        <span class="sidebar-content">
          @if (isOverviewEnabled === 'enabled') {
            <span id="profile-overview-link">{{ 'sideBar.overview' | translate }}</span>
          }
        </span>
      </a>
    </fdx-nav-item>
  }


  <fdx-nav-item [active]="activeLink === 'loginSecurity'">
    <a fdxNavButton [href]="navUrls.loginSecurity" (click)="setActive('loginSecurity', $event, navUrls.loginSecurity)">


      <ciam-icon fdxNavIcon key="brand_key_s"></ciam-icon>
      <span  id="login-security-link" class="sidebar-content">
        {{ 'sideBar.loginSecurity' | translate }}
      </span>
    </a>
  </fdx-nav-item>

  <fdx-nav-item [active]="activeLink === 'contactInformation'">
    <a fdxNavButton [href]="navUrls.contactInfo" (click)="setActive('contactInformation', $event, navUrls.contactInfo)">
      <ciam-icon fdxNavIcon key="utility_circle_user"></ciam-icon>
      <span  id="contact-information-link" class="sidebar-content" >
        {{ 'sideBar.contactInformation' | translate }}
      </span>
    </a>
  </fdx-nav-item>

  @if (!isWpapDecoupled && !isPolaris) {
    <fdx-nav-item
      class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only" >
      <a fdxNavButton
        [href]="navUrls.legacyAccountManagement">
        <ciam-icon fdxNavIcon key="box-open"></ciam-icon>
        <span id="account-management-link" class="sidebar-content">
          {{ 'sideBar.accountAndPayments' | translate }}
        </span>
      </a>
    </fdx-nav-item>
  }

  @if (isWpapDecoupled || isPolaris) {
    <fdx-nav-item
      class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only" >
      <a fdxNavButton
        [href]="navUrls.accountManagement">
        <ciam-icon fdxNavIcon key="box-open"></ciam-icon>
        <span id="account-management-link" class="sidebar-content">
          {{ 'sideBar.accountAndPayments' | translate }}
        </span>
      </a>
    </fdx-nav-item>
  }

  @if (isFdmEnabled !== 'disabled') {
    <fdx-nav-item
      class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only">
      <a fdxNavButton [href]="navUrls.deliveryManager" >
        <ciam-icon fdxNavIcon key="brand_courier_s"></ciam-icon>
        <span class="sidebar-content">
          @if (isFdmEnabled === 'loading') {
            <span style="text-align: center !important; display: block">
              <wpro-spinner-small></wpro-spinner-small>
            </span>
          }
          @if (isFdmEnabled === 'enabled') {
            <span id="fedEx-delivery-manager-link">{{ 'sideBar.fedExDeliveryManager' | translate }}</span>
          }
        </span>
      </a>
    </fdx-nav-item>
  }

  <fdx-nav-item class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only">
    <a fdxNavButton [href]="navUrls.shippingAdmin" >
      <ciam-icon fdxNavIcon key="brand_user_groups_s"></ciam-icon>
      <span id="shipping-administration-link" class="sidebar-content">
        {{ 'sideBar.shippingAdministration' | translate }}
      </span>
    </a>
  </fdx-nav-item>

  <fdx-nav-item class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only">
    <a fdxNavButton
      [href]="preferencesUrl">
      <ciam-icon fdxNavIcon key="brand_self_service_ship_s"></ciam-icon>
      <span  id="preferences-link" class="sidebar-content">
        {{ 'sideBar.preferences' | translate }}
      </span>
    </a>
  </fdx-nav-item>

  @if (isClearanceProfileEnabled === 'enabled') {
    <fdx-nav-item class="fdx-u-hidden@x-small-only fdx-u-hidden@small-only">
      <a fdxNavButton [href]="navUrls.clearanceProfile" (click)="recordClearanceProfileClick()">
        <ciam-icon fdxNavIcon key="brand_customs_agent_s"></ciam-icon>
        <span id="clearance-profile-link" class="sidebar-content">
          {{ 'sideBar.clearanceProfile' | translate }}
        </span>
      </a>
    </fdx-nav-item>
  }

  <!-- mobile navigation-->

  <fdx-nav-item class="fdx-u-hidden@medium">
    <button fdxNavButton>
      <ciam-icon fdxNavIcon key="navigational_kebab"></ciam-icon>
      <span>{{ 'sideBar.more' | translate }}</span>
    </button>
    <fdx-nav-menu #moreMenu>
      @if (isOverviewEnabled !== 'disabled') {
        <fdx-nav-item>
          <a fdxNavButton [href]="navUrls.profileOverview" >
            <span class="sidebar-content">
              @if (isOverviewEnabled === 'loading') {
                <span style="text-align: center !important; display: block">
                  <overview-spinner-small></overview-spinner-small>
                </span>
              }
              @if (isOverviewEnabled === 'enabled') {
                <span id="profile-overview-link">{{ 'sideBar.overview'|
                translate }}</span>
              }
            </span>
          </a>
        </fdx-nav-item>
      }

      @if (!isWpapDecoupled && !isPolaris) {
        <fdx-nav-item>
          <a fdxNavButton
            [href]="navUrls.legacyAccountManagement" >
            <span id="account-management-link" class="sidebar-content">
              {{ 'sideBar.accountAndPayments' | translate }}
            </span>
          </a>
        </fdx-nav-item>
      }

      @if (isWpapDecoupled || isPolaris) {
        <fdx-nav-item>
          <a fdxNavButton
            [href]="navUrls.accountManagement" >
            <span id="account-management-link" class="sidebar-content">
              {{ 'sideBar.accountAndPayments' | translate }}
            </span>
          </a>
        </fdx-nav-item>
      }

      @if (isFdmEnabled !== 'disabled') {
        <fdx-nav-item>
          <a fdxNavButton [href]="navUrls.deliveryManager" >
            <span class="sidebar-content">
              @if (isFdmEnabled === 'loading') {
                <span style="text-align: center !important; display: block">
                  <overview-spinner-small></overview-spinner-small>
                </span>
              }
              @if (isFdmEnabled === 'enabled') {
                <span id="fedEx-delivery-manager-link">{{
                'sideBar.fedExDeliveryManager' | translate }}</span>
              }
            </span>
          </a>
        </fdx-nav-item>
      }



      <fdx-nav-item>
        <a fdxNavButton [href]="navUrls.shippingAdmin" >
          <span id="shipping-administration-link" class="sidebar-content">
            {{ 'sideBar.shippingAdministration' | translate }}
          </span>
        </a>
      </fdx-nav-item>

      <fdx-nav-item>
        <a fdxNavButton
          [href]="preferencesUrl" >
          <span id="preferences-link" class="sidebar-content">
            {{ 'sideBar.preferences' | translate }}
          </span>
        </a>
      </fdx-nav-item>

      @if (isClearanceProfileEnabled === 'enabled') {
        <fdx-nav-item>
          <a fdxNavButton [href]="navUrls.clearanceProfile" (click)="recordClearanceProfileClick()">
            <span id="clearance-profile-link" class="sidebar-content">
              {{ 'sideBar.clearanceProfile' | translate }}
            </span>
          </a>
        </fdx-nav-item>
      }
    </fdx-nav-menu>
  </fdx-nav-item>
  <div class="fdx-u-m--0 fdx-u-m--2@x-small">
    <ng-content></ng-content>
  </div>
</fdx-nav>
